<div class="mt-loader" [ngClass]="variant">
  @if (variant !== 'small') {
    <img src="../../../../../assets/img/logo/loader.png" width="40" />
  }
  <!-- spinner -->
  <svg class="load-spinner" viewBox="25 25 50 50">
    <circle class="load-path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
  </svg>
</div>
